import React, { Fragment, useEffect, useState } from "react";
import GreenTick from "../../assets/images/green_tick.svg";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import * as apicall from "../../components/Apicall";
import CurrencyDropdown from "./CurrencyDropdown";

const Setup = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = React.useState(0);
  const [completedSteps, setCompletedSteps] = useState({
    profile: false,
    service: false,
    type: false,
    crew: false,
    order: false,
  });

  useEffect(() => {
    fetchProgress();
  }, []);

  async function fetchProgress() {
    try {
      setLoading(true);
      let [
        ezpMyProfile,
        services_api,
        service_type_api,
        get_ezp_service_providers,
        get_ezp_booking,
      ] = await Promise.all([
        apicall.get(`ezpMyProfile`),
        apicall.get(`get_ezp_service`),
        apicall.get(`get_ezp_service_types`),
        apicall.get(`get_ezp_service_providers`),
        apicall.get(`get_ezp_booking?page=1&limit=1`),
      ]);
      let ans = {
        profile: ezpMyProfile?.data?.[0]?.state_name ? true : false,
        service: services_api?.data?.length > 0,
        type: service_type_api?.data?.length > 0,
        crew: get_ezp_service_providers?.data?.length > 0,
        order: get_ezp_booking?.data?.length > 0,
      };
      setUserName(ezpMyProfile?.data?.[0]?.first_name || "");
      let totalPercentage = Object.values(ans).filter((val) => val).length * 20;
      console.log("ans--", ans, totalPercentage);
      setProgress(totalPercentage);
      setCompletedSteps(ans);
      localStorage.setItem("setupCompleted", totalPercentage === 100 ? "true" : "false");
      setLoading(false);
    } catch (e) {
      console.log("Error fetching progress: ", e);
      setLoading(false);
    }
  }

  async function next() {}

  let allSteps = [
    {
      title: "Complete Profile",
      description: "Add sub content",
      navigate: "/vendors/view-profile",
      status: "profile",
    },
    {
      title: "Service Creation",
      description: "Add sub content",
      navigate: "/add_offerings",
      status: "service",
    },
    {
      title: "Service Type Creation",
      description: "Add sub content",
      navigate: "/add_offerings",
      status: "type",
    },
    {
      title: "Crew Creation",
      description: "Add sub content",
      navigate: "/providers",
      status: "crew",
    },
    {
      title: "Order Booking",
      description: "Add sub content",
      navigate: "/vendor_bookings",
      status: "order",
    },
  ];

  const navigateToPage = (ele) => {
    try {
      console.log("ele?.navigate--", ele?.navigate);
      navigate(ele?.navigate);
    } catch (e) {
      console.log("Error navigating to page: ", e);
    }
  };

  async function boxCLick(ele, index) {
    try {
      if (Object.values(completedSteps)[index - 1]) {
        navigateToPage(ele);
      } else {
        if (index === 0) navigateToPage(ele);
        next();
      }
    } catch (e) {
      console.log("err----", e);
    }
  }

  console.log(completedSteps, "completedSteps");

  return (
<div className="flex-center setup-container">
  <div className="inner-setup-container">
        <div className="w-100">
          <div style={{ textAlign: "center", marginBottom: "0.5rem" }}>
            {loading ? "Loading...." : `Let's get you setup, ${userName}!`}
          </div>
          <div className="setupBox">  
            <div className="d-flex justify-between align-center mb-3 w-100">
              <div>Geting Started</div>
              <div>{progress / 20}/5 completed</div>
            </div>
            <div style={styles.container}>
              <div
                style={{
                  ...styles.filler,
                  width: `${progress}%`,
                }}
              >
                         <span className="progress-label" style={styles.label}>{progress}%</span>

              </div>
            </div>
            <div style={{ marginTop: "1rem" }}>
              {allSteps.map((ele, index) => (
                <div
                  onClick={() => {
                    boxCLick(ele, index);
                  }}
                  className={[
                    "eachSetup",
                    completedSteps[ele?.status] && "completedBOX",
                    !Object.values(completedSteps)[index - 1] && "opacityBOX",
                    index === 0 && "opacityFull",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                  key={index}
                >
                  <div className="d-flex gap-4">
                    <div style={{ fontWeight: 600, fontSize: "1.5rem" }}>
                      {index + 1}
                    </div>
                    <div className="flex-col gap-2">
                      <div>{ele?.title}</div>
                      <div>{ele?.description}</div>
                    </div>
                  </div>
                  <div>
                    {completedSteps[ele?.status] ? (
                      <img
                        src={GreenTick}
                        className="greenTick"
                        alt="GreenTick"
                      />
                    ) : (
                      <div className="rightArrow">
                        <FaArrowRight />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setup;
const styles = {
  container: {
    height: "20px",
    width: "100%",
    backgroundColor: "#e0e0df",
    borderRadius: "10px",
  },
  filler: {
    height: "100%",
    backgroundColor: "#38A60D",
    borderRadius: "inherit",
    textAlign: "right",
    transition: "width 0.4s ease-in-out",
  },
  label: {
    padding: "6px",
    color: "white",
    fontWeight: "bold",
    fontSize: "12px",
  },
};
